// extracted by mini-css-extract-plugin
export default {"activities":"ListActivitiesTab_activities__IbR0E","table":"ListActivitiesTab_table__KxZ0q"};